// extracted by mini-css-extract-plugin
export default {"container":"GameTile_container__5TBUN"};